// Phase 18 · Community · Video embed (YouTube/Vimeo/Loom)
import React from "react";

function toEmbedUrl(url) {
    try {
        const u = new URL(url);
        const host = u.hostname.replace(/^www\./, "");
        // YouTube
        if (host === "youtube.com" || host === "m.youtube.com") {
            const id = u.searchParams.get("v");
            if (id) return `https://www.youtube.com/embed/${id}`;
        }
        if (host === "youtu.be") {
            const id = u.pathname.split("/")[1];
            if (id) return `https://www.youtube.com/embed/${id}`;
        }
        // Vimeo
        if (host.endsWith("vimeo.com")) {
            const id = u.pathname.split("/").filter(Boolean).pop();
            if (id) return `https://player.vimeo.com/video/${id}`;
        }
        // Loom
        if (host.endsWith("loom.com")) {
            const parts = u.pathname.split("/").filter(Boolean);
            const idx = parts.findIndex((p) => p === "share");
            const id = idx >= 0 ? parts[idx + 1] : parts.pop();
            if (id) return `https://www.loom.com/embed/${id}`;
        }
    } catch {}
    return null;
}

export default function VideoEmbed({ url }) {
    const embed = toEmbedUrl(url);
    if (!embed) {
        return (
            <a
                href={url}
                target="_blank"
                rel="noreferrer noopener"
                className="inline-flex items-center gap-1 text-sm text-[#FFFFFF] hover:text-[#CCCCCC]"
            >
                {url}
            </a>
        );
    }
    return (
        <div
            className="relative w-full rounded-lg overflow-hidden border border-[#1A1A1A]"
            style={{ paddingTop: "56.25%" }}
            data-testid="video-embed"
        >
            <iframe
                src={embed}
                title="Video embed"
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
}
